<template>
  <b-row>
    <b-col cols="12" xl="12">  
      <b-card>
        <template slot="header">
          Deuda de Clientes - {{ tituloFecha }}
        </template> 
        <b-table 
            class="registro"
            responsive
            :no-border-collapse="true"
            :busy="tableBusy"
            :items="resultados" 
            :fields="fields"
            :current-page="paginaActual"
            :per-page="registrosPorPagina">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>
          <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
          </template>
          <template v-slot:cell(fechaVencimiento)="data">
              {{ data.item.fechaVencimiento | fecha }}
          </template>
          <template v-slot:cell(comprobante)="data">
              {{ (data.item.comprobanteTipo + " " + data.item.comprobanteNumero) }}
          </template>
          <template v-slot:cell(importe)="data">
            {{ data.item.importe | moneda(data.item.moneda) }}
          </template>
          <template v-slot:cell(saldo)="data">
            {{ data.item.saldo | moneda(data.item.moneda) }}
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'flujoFondos/getField',
  mutationType: 'flujoFondos/updateField',
});

export default {
  name: 'FlujoFondosDeudaClientes',
  props: {
    fechaResultados: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      fields: [
        { 
          key: 'fechaComprobante',
          label: 'Fecha Comp.' 
        },
        { 
          key: 'fechaVencimiento',
          label: 'Fecha Venc.' 
        },
        { key: 'cliente' },
        { key: 'comprobante' },
        { key: 'comprobanteNumero' },
        { 
          key: 'importe',
          class: 'text-right' 
        },
        { 
          key: 'saldo',
          class: 'text-right' 
        },
      ],
      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'resultados',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
    ]),
    tituloFecha() {
      return moment(this.fechaResultados).format('DD/MM/YYYY');
    }
  },
}
</script>

<style>
</style>
